import { Directive } from '@angular/core';
var LyTabLabelDirective = /** @class */ (function () {
    function LyTabLabelDirective() {
    }
    LyTabLabelDirective.decorators = [
        { type: Directive, args: [{
                    selector: 'ly-tab-label, [ly-tab-label]'
                },] },
    ];
    /** @nocollapse */
    LyTabLabelDirective.ctorParameters = function () { return []; };
    return LyTabLabelDirective;
}());
export { LyTabLabelDirective };
//# sourceMappingURL=tab-label.directive.js.map